import React, { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

/**
 * On web, we do NOT use @stripe/stripe-react-native. Just render children.
 */
const StripeProviderWrapper: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default StripeProviderWrapper;